<h2 mat-dialog-title>Table Properties</h2>

<mat-dialog-content class="table-props-dialog">
  <div class="props-section">
    <h3>Table Width</h3>
    <div class="width-controls">
      <mat-form-field appearance="outline" style="width: 120px;">
        <mat-label>Width</mat-label>
        <input [attr.guide]="'table-properties-dialog-inp-1' + '__' + sanitizeUrl(url)" matInput type="number" [(ngModel)]="properties.widthValue" min="1" [max]="properties.widthType === 'percent' ? 100 : 9999"/>
      </mat-form-field>
      
      <mat-radio-group [(ngModel)]="properties.widthType" (change)="onWidthTypeChange()" style="margin-left: 12px;">
        <mat-radio-button [attr.guide]="'table-properties-dialog-chk-2' + '__' + sanitizeUrl(url)" value="percent" style="margin-right: 12px;">%</mat-radio-button>
        <mat-radio-button [attr.guide]="'table-properties-dialog-chk-3' + '__' + sanitizeUrl(url)" value="pixels">px</mat-radio-button>
      </mat-radio-group>
    </div>
  </div>

  <div class="props-section">
    <h3>Table Alignment</h3>
    <mat-radio-group [(ngModel)]="properties.alignment">
      <mat-radio-button [attr.guide]="'table-properties-dialog-chk-4' + '__' + sanitizeUrl(url)" value="left" style="margin-right: 12px;">Left</mat-radio-button>
      <mat-radio-button [attr.guide]="'table-properties-dialog-chk-5' + '__' + sanitizeUrl(url)" value="center" style="margin-right: 12px;">Center</mat-radio-button>
      <mat-radio-button [attr.guide]="'table-properties-dialog-chk-6' + '__' + sanitizeUrl(url)" value="right">Right</mat-radio-button>
    </mat-radio-group>
  </div>

  <div class="props-section">
    <h3>Table Margins</h3>
    <div class="prop-row">
      <mat-form-field appearance="outline" style="width: 120px;">
        <mat-label>Margin Left (px)</mat-label>
        <input [attr.guide]="'table-properties-dialog-inp-7' + '__' + sanitizeUrl(url)" matInput type="number" [(ngModel)]="properties.marginLeft" min="0" max="500"/>
      </mat-form-field>

      <mat-form-field appearance="outline" style="width: 120px; margin-left: 12px;">
        <mat-label>Margin Right (px)</mat-label>
        <input [attr.guide]="'table-properties-dialog-inp-8' + '__' + sanitizeUrl(url)" matInput type="number" [(ngModel)]="properties.marginRight" min="0" max="500"/>
      </mat-form-field>
    </div>
  </div>

  <div class="props-section">
    <h3>Border Properties</h3>
    
    <div class="prop-row">
      <mat-form-field appearance="outline" style="width: 150px;">
        <mat-label>Border Style</mat-label>
        <mat-select [(ngModel)]="properties.borderStyle">
          <mat-option *ngFor="let style of borderStyles" [value]="style.value">
            {{ style.label }}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field appearance="outline" style="width: 100px; margin-left: 12px;">
        <mat-label>Width (px)</mat-label>
        <input [attr.guide]="'table-properties-dialog-inp-9' + '__' + sanitizeUrl(url)" matInput type="number" [(ngModel)]="properties.borderWidth" min="0" max="20"/>
      </mat-form-field>
    </div>

    <div class="prop-row">
      <label class="color-label">Border Color</label>
      <div class="color-picker-section">
        <div class="color-preview" [style.background]="properties.borderColor" (click)="colorPicker.click()"></div>
        <input [attr.guide]="'table-properties-dialog-inp-10' + '__' + sanitizeUrl(url)" #colorPicker type="color" [(ngModel)]="properties.borderColor" style="margin-left: 8px;"/>
        
        <div class="preset-colors">
          <button [attr.guide]="'table-properties-dialog-btn-11' + '__' + sanitizeUrl(url)" mat-icon-button *ngFor="let c of presetColors.slice(0, 16)" 
                  class="color-swatch" 
                  [style.background]="c"
                  (click)="properties.borderColor = c"
                  [class.selected]="properties.borderColor === c">
          </button>
        </div>
      </div>
    </div>
  </div>

  <div class="props-section">
    <h3>Cell Properties</h3>
    
    <div class="prop-row">
      <mat-form-field appearance="outline" style="width: 120px;">
        <mat-label>Cell Padding (px)</mat-label>
        <input [attr.guide]="'table-properties-dialog-inp-12' + '__' + sanitizeUrl(url)" matInput type="number" [(ngModel)]="properties.cellPadding" min="0" max="50"/>
      </mat-form-field>

      <mat-form-field appearance="outline" style="width: 120px; margin-left: 12px;">
        <mat-label>Cell Spacing (px)</mat-label>
        <input [attr.guide]="'table-properties-dialog-inp-13' + '__' + sanitizeUrl(url)" matInput type="number" [(ngModel)]="properties.cellSpacing" min="0" max="50"/>
      </mat-form-field>
    </div>
  </div>

  <div class="props-section">
    <h3>Background Color</h3>
    <div class="prop-row">
      <div class="color-picker-section">
        <div class="color-preview" [style.background]="properties.backgroundColor" (click)="bgColorPicker.click()"></div>
        <input [attr.guide]="'table-properties-dialog-inp-14' + '__' + sanitizeUrl(url)" #bgColorPicker type="color" [(ngModel)]="properties.backgroundColor" style="margin-left: 8px;"/>
        
        <button [attr.guide]="'table-properties-dialog-btn-15' + '__' + sanitizeUrl(url)" mat-button (click)="properties.backgroundColor = 'transparent'" style="margin-left: 8px;">
          Transparent
        </button>
        
        <div class="preset-colors">
          <button [attr.guide]="'table-properties-dialog-btn-16' + '__' + sanitizeUrl(url)" mat-icon-button *ngFor="let c of presetColors.slice(0, 16)" 
                  class="color-swatch" 
                  [style.background]="c"
                  (click)="properties.backgroundColor = c"
                  [class.selected]="properties.backgroundColor === c">
          </button>
        </div>
      </div>
    </div>
  </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button [attr.guide]="'table-properties-dialog-btn-17' + '__' + sanitizeUrl(url)" mat-button (click)="cancel()">Cancel</button>
  <button [attr.guide]="'table-properties-dialog-btn-18' + '__' + sanitizeUrl(url)" mat-raised-button color="primary" (click)="save()">Apply</button>
</mat-dialog-actions>
